import { FaHardHat } from "react-icons/fa";
import Button from "../../components/ui/Button";

export default function NotFound() {
  return (
    <section className="container-pad grid min-h-[70vh] place-items-center py-16 text-center">
      <div className="max-w-xl">
        <FaHardHat className="mx-auto text-6xl text-primary" />
        <p className="mt-6 text-sm font-bold uppercase tracking-wider text-primary">404 Page</p>
        <h1 className="mt-3 text-4xl font-bold text-dark sm:text-5xl">Page not found</h1>
        <p className="mt-4 leading-7 text-body">The catalogue page you are looking for may have moved or does not exist.</p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Button to="/">Back Home</Button>
          <Button to="/products" variant="secondary">Browse Products</Button>
        </div>
      </div>
    </section>
  );
}
